import { FC } from 'react';

import { formatNumber } from 'src/utils/common';

import useProductById from 'src/hooks/swr/useProductById';
import useSWRProductInventory from 'src/hooks/swr/useSWRProductInventory';

/**
 * 상품 -> 재고 -> 재고량
 * 두 번의 조회를 통해 재고량을 표시합니다.
 */
const AgCellProductQuantity: FC<{ productId: string; volume: number }> = ({ productId, volume }) => {
  const { product, productLoading } = useProductById(productId);
  const { inventory, isLoading: inventoryLoading } = useSWRProductInventory(product?.inventoryId ?? null);

  if (productLoading || inventoryLoading) {
    return <div>isLoading</div>;
  }

  if (inventory?.quantity === undefined) {
    return <span>?</span>;
  }

  const isExceed = inventory?.quantity < volume;
  const exceed = inventory?.quantity - volume;

  return (
    <span style={isExceed ? { color: 'var(--red400)', fontWeight: 'bold' } : undefined}>
      {inventory.quantity === Infinity ? '' : formatNumber(inventory.quantity)}
      {isExceed ? `(${exceed})` : ''}
    </span>
  );
};

export default AgCellProductQuantity;
